import { z } from 'zod';
import { InstanceIdSchema } from './auth.js';
/**
 * Progression events. `progress` goes to its owner only — another player's
 * experience is nobody's business (CADRAGE: stats are never synchronised);
 * `level_up` is broadcast so everyone sees the flash.
 */
export const ProgressEventSchema = z.object({
    xp: z.number().int().min(0),
    level: z.number().int().min(1),
    /** Total XP at which the current level started and at which the next begins. */
    levelStartXp: z.number().int().min(0),
    nextLevelXp: z.number().int().min(0),
    maxHp: z.number().int().positive(),
    /** XP just earned, on a kill only: what the client floats as "+N XP". */
    gained: z.number().int().positive().optional(),
});
export const LevelUpEventSchema = z.object({
    /** Session id of the player who levelled. */
    id: z.string().min(1),
    level: z.number().int().min(2),
});
/**
 * Told to a player leaving by an exit: the zone to join next, where they
 * already stand, and the instance of it they were let into when it is one
 * (ADR 0068); none for any other zone.
 */
export const ZoneChangeEventSchema = z.object({
    zoneId: z.string().min(1),
    x: z.number().int().min(0),
    y: z.number().int().min(0),
    instanceId: InstanceIdSchema.optional(),
});
/** Told to the fallen player alone: what it cost, and when they get back up. */
export const DeathEventSchema = z.object({
    xpLost: z.number().int().min(0),
    respawnInMs: z.number().int().min(0),
});
//# sourceMappingURL=progress.js.map